import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { backendUrl } from 'src/environments/environment';
import { Category } from './category.store';
import { toPromise } from './toPromise';
import { Variant, VariantField } from './seller-product.store';
import { BehaviorSubject } from 'rxjs';

export interface ProductsResponse {
  status: number;
  data: {
    product: Array<Product>;
    suggested_products: Array<Product>;
    total: number;
    total_unlisted: number;
    total_in_store: number;
    total_sold_out: number;
  };
}
export interface ProductDetailResponse {
  status: number;
  data: seller;
}
export interface Location {
  id: number;
  country: string;
  province: string;
  town: string;
  street: string;
  house_no: number;
  building: string;
  pincode: string;
  area: string;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
}
export interface Product {
  id: number;
  seller_id: number;
  sku: string;
  product_name: string;
  category: Category;
  subcategory: Category;
  product_price: number;
  actual_price: number;
  product_description: string;
  product_condition: number;
  is_avail_delivery: number;
  is_avail_pickup: number;
  storage_locations: number;
  pickup_locations: number;
  is_featured: number;
  trending_search_count: Date;
  is_saved: Boolean;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
  seller: seller;
  images: Array<Image>;
  product_fields: Array<productfields>;
  product_variations: Array<productVariations>;
  storage_location: Location;
  pickup_location: Location;
  inventory: number;
  selected?: boolean;
  qty: number;
  views: number;
  total_saved: number;
  total_sold: number;
  price?: number;
  product_id?: number;
  option_data: number;
  options: Array<Option>;
  options_selected: Array<Option>;
  out_of_stock: number;
  products: Array<Product>;
  video_thumbnail: string;
  video_full: string;
  status: number;
  product_highlight: boolean;
  target_audience: string;
  slug: string;
  is_rentable: number;
  rental_price: number;
  when_return_days: number;
  selectedDate: Date;
}

export interface Image {
  id: number;
  product_id: number;
  thumbnail: string;
  full: string;
  type: number;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
}
export interface seller {
  id: number;
  user_id: number;
  shop_name: string;
  email: string;
  phone: number;
  phone_code: number;
  profile_photo: string;
  banner_photo: string;
  shop_url: string;
  shop_title: string;
  shop_body: string;
  storage_locations: number;
  pickup_locations: number;
  is_account_verified: number;
  business_id: number;
  id_proof: number;
  notification_limits: number;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
  product: Product;
  total_seller_products: number;
  follower_count: number;
  slug: string;
}
export interface productfields {
  id: number;
  product_id: number;
  field_title: string;
  field_input: string;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
}
export interface variant {
  product_id: number;
  variation_type: number;
  size_type: string;
  img: string;
  variation_name: string;
  variation_price: number;
  inventory: number;
  sku: string;
  created_at: Date;
  updated_at: Date;
  id: number;
  variation_fields: Array<{
    variation_price?: number;
    size_type?: string;
    inventory?: number;
    sku?: string;
    id: number;
  }>;
}
export interface productVariations {
  id: number;
  variation_name: string;
  seller_id: number;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
  variant: Array<variant>;
}

export enum SortFilter {
  MostPopular,
  LowToHigh,
  HighToLow,
  Latest,
  Oldest,
}
export interface Option {
  id: number;
  product_id: number;
  img: string;
  variation_name: string;
  variation_price: number;
  variation_type: number;
  inventory: number;
  sku: string;
  created_at: string;
  updated_at: string;
  deleted_at: Date;
  variation_types: VariationType;
  product_variation_id: number;
  product_variation: Variant;
  variation_field: VariantField;
  size_type: string;
}
export interface VariationType {
  id: number;
  variation_name: string;
  seller_id: number;
}
@Injectable({
  providedIn: 'root',
})
export class ProductStore {
  activeIndex: BehaviorSubject<number> = new BehaviorSubject(null);

  sortFilter: SortFilter = null;
  constructor(private httpClient: HttpClient) {}

  async getProducts(
    params = null,
    seller: boolean = false
  ): Promise<ProductsResponse> {
    var url: string;
    const token = localStorage.getItem('authToken');
    // params.product_sort_status = this.sortFilter
    if (!seller) {
      url = `${backendUrl}product`;
    } else {
      url = `${backendUrl}seller/product`;
    }
    return toPromise(
      this.httpClient.get<ProductsResponse>(url, {
        params: params,
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
  async getProductDetail(
    productId: number,
    seller: boolean
  ): Promise<ProductDetailResponse> {
    let url: string;
    if (!seller) {
      url = `${backendUrl}product/${productId}`;
    } else {
      url = `${backendUrl}seller/product/${productId}`;
    }
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<ProductDetailResponse>(url, {
        params: {
          product_sort_status: this.sortFilter,
        },
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async saveUnsaveProduct(productId: number): Promise<void> {
    const url = `${backendUrl}wishlist`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(
        url,
        { product_id: productId },
        {
          params: {},
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        }
      )
    );
  }
  async getWishList(params = null): Promise<ProductsResponse> {
    const url = `${backendUrl}wishlist`;
    const token = localStorage.getItem('authToken');
    params.product_sort_status = this.sortFilter;
    return toPromise(
      this.httpClient.get<ProductsResponse>(url, {
        params: params,
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async publishProduct(productId: number, status: number): Promise<void> {
    const url = `${backendUrl}seller/product-publish`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(
        url,
        { product_id: productId, status: status },
        {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        }
      )
    );
  }

  async deleteProduct(productId: number): Promise<void> {
    const url = `${backendUrl}seller/product/${productId}`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.delete<void>(url, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
}
